import loadAppsLogic from "./loadAppsLogic";
import loadUsersLogic from "./loadUsersLogic";
import createAppLogic from "./createAppLogic";
import createAppSuccessLogic from "./createAppSuccessLogic";
import createAppFailLogic from "./createAppFailLogic";
import editAppLogic from "./editAppLogic";
import editAppSuccessLogic from "./editAppSuccessLogic";
import editAppFailLogic from "./editAppFailLogic";
import deleteAppLogic from "./deleteAppLogic";
import deleteAppSuccessLogic from "./deleteAppSuccessLogic";
import deleteAppFailLogic from "./deleteAppFailLogic";
import editAppNavigationLogic from "./editAppNavigationLogic";
import loadAppNavigationLogic from "./loadAppNavigationLogic";

export default [
	...loadAppsLogic,
	...loadUsersLogic,
	...createAppLogic,
	...createAppSuccessLogic,
	...createAppFailLogic,
	...editAppLogic,
	...editAppSuccessLogic,
	...editAppFailLogic,
	...deleteAppLogic,
	...deleteAppSuccessLogic,
	...deleteAppFailLogic,
	...editAppNavigationLogic,
	...loadAppNavigationLogic,
];
